import { safelyRetrieveStorage, SELECTED_ZIP } from './helpers/localStorageKeys'

export const getZipFromStorage = searchParams => {
  return searchParams.get('zip')
    ? searchParams.get('zip')
    : safelyRetrieveStorage(SELECTED_ZIP)
    ? JSON.parse(safelyRetrieveStorage(SELECTED_ZIP)).postalCode
    : ''
}
